import { render, staticRenderFns } from "./cancelorder2.vue?vue&type=template&id=542f29f1&scoped=true"
import script from "./cancelorder2.vue?vue&type=script&lang=js"
export * from "./cancelorder2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f29f1",
  null
  
)

export default component.exports